import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { getRevenueTrendsForWorkShop } from "../../../Api/Api";

// Register required chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const RevenueTrendsChart = ({ workshopId }) => {
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                getRevenueTrendsForWorkShop(workshopId)
                    .then((response) => {
                        generateChart(response.data);
                    });
            } catch (error) {
                console.error("Error fetching revenue trends data:", error);
            }
        };

        fetchData();
    }, [workshopId]);

    const generateChart = (data) => {
        if (!data || data.length === 0) {
            setChartData(null);
            return;
        }

        // Extract unique months in sorted order
        const months = [...new Set(data.map(item => `${item.year}-${item.month}`))].sort();

        // Extract unique work types
        const workTypes = [...new Set(data.map(item => item.workType))];

        // Map data for Chart.js
        const datasets = workTypes.map(workType => ({
            label: workType,
            data: months.map(month => {
                const found = data.find(item => `${item.year}-${item.month}` === month && item.workType === workType);
                return found ? found.totalRevenue : 0;
            }),
            backgroundColor: getRandomColor(),
        }));

        setChartData({
            labels: months.map(m => {
                const [year, month] = m.split("-");
                return `${getMonthName(month)} ${year}`;
            }),
            datasets,
        });
    };

    const getMonthName = (month) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return monthNames[parseInt(month) - 1];
    };

    const getRandomColor = () => `hsl(${Math.random() * 360}, 70%, 60%)`;

    return (
        <div className="p-4 bg-white rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4">Revenue Trends by Service Type</h2>
            {chartData ? (
                <Bar
                    data={chartData}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: { position: "top" },
                            title: { display: true, text: "Revenue Trends" },
                            tooltip: { callbacks: { label: context => `INR${context.raw.toFixed(2)}` } },
                        },
                        scales: {
                            y: { title: { display: true, text: "Total Revenue (INR)" } },
                            x: { title: { display: true, text: "Month & Year" } },
                        },
                    }}
                />
            ) : (
                <p>No revenue data available</p>
            )}
        </div>
    );
};

export default RevenueTrendsChart;
